module.exports = __webpack_public_path__ + "img/logo-bg.57aebbb0.jpg";